module.exports = __webpack_public_path__ + "img/doc.839845da.png";